'use client';

import Script from 'next/script';
import { useEffect, useState } from 'react';

interface Props {
    publicFolderPrefix: string;
    locale: string;
}

declare global {
    interface Window {
        _genesys?: {
            widgets?: {
                main?: {
                    i18n?: string;
                    lang?: string;
                };
            };
        };
        _gt?: unknown[];
        CXBus?: {
            command: (command: string, options?: unknown) => void;
        };
    }
}

export function LivechatWidget({ publicFolderPrefix, locale }: Props) {
    const [configLoaded, setConfigLoaded] = useState(false);

    useEffect(() => {
        const stylesLink = document.createElement('link');
        stylesLink.id = 'genesys-widgets-styles';
        stylesLink.rel = 'stylesheet';
        stylesLink.type = 'text/css';
        stylesLink.href = `${publicFolderPrefix}/livechat/widgets.min.css`;
        document.head.appendChild(stylesLink);

        const themeLink = document.createElement('link');
        themeLink.id = 'genesys-theme-styles';
        themeLink.rel = 'stylesheet';
        themeLink.type = 'text/css';
        themeLink.href = `${publicFolderPrefix}/livechat/cx-theme-cmp.css`;
        document.head.appendChild(themeLink);

        return () => {
            if (window.CXBus) {
                try {
                    window.CXBus.command('WebChat.close');
                    window.CXBus.command('WebChat.endChat');
                } catch {}
            }

            stylesLink.remove();
            themeLink.remove();

            const genesysSelectors = [
                '.cx-widget',
                '.cx-overlay',
                '.cx-sidebar',
                '.cx-webchat',
                '.cx-toaster',
                '.cx-window-manager',
                '[class^="cx-"]',
                '#genesys-mxg-frame',
            ];

            genesysSelectors.forEach(selector => {
                document.querySelectorAll(selector).forEach(el => el.remove());
            });

            if (window._genesys) {
                delete window._genesys;
            }
            if (window._gt) {
                delete window._gt;
            }
            if (window.CXBus) {
                delete window.CXBus;
            }
        };
    }, [publicFolderPrefix]);

    const handleConfigLoad = () => {
        if (window._genesys?.widgets?.main) {
            window._genesys.widgets.main.i18n = `${publicFolderPrefix}/livechat/widgets-lng.i18n.json`;
            window._genesys.widgets.main.lang = locale;
        }
        setConfigLoaded(true);
    };

    return (
        <>
            <Script
                id="genesys-widgets-config"
                src={`${publicFolderPrefix}/livechat/widgets.config.js`}
                strategy="afterInteractive"
                onLoad={handleConfigLoad}
            />

            {configLoaded && (
                <Script
                    id="genesys-widgets"
                    src={`${publicFolderPrefix}/livechat/widgets.min.js`}
                    strategy="afterInteractive"
                />
            )}
        </>
    );
}
